import app from '../../../scripts/app';
import template from './ad-submit-jk.jade';

app.directive('cianAfAdSubmitJk', ['apiService', 'adStateService', 'popupService', 'deviceService', (apiService, adStateService, popupService, deviceService) => {
  return {
    template,
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
      termsIsFailed: '=',
    },
    controller: [function () {
      this.isMobile = deviceService.isMobile;
      this.add = () => {
        const data = adStateService.cleanAdModel({
          building: this.ad.building,
          geo: this.ad.geo
        });
        apiService.addJK(data).then(res => {
          if (res && res.data && res.data.status === 'saved') {
            popupService.openPopup('jkAdd');
          } else {
            popupService.openPopup('serverError');
          }
        });
      }
    }],
    controllerAs: 'adSubmitJk',
    replace: true,
  };
}]);
